import { dispatcher } from '../../../../helpers/projectHelper';
import { configuratorUnityObjectActions } from '../../../../redux/slicers/configurator/configuratorUnityObject.slicer';
import { configuratorBridge } from '../../../Configurator/unity/unityMethods';

export class UndoRedoConfiguratorTransformationPanel {
  constructor({ undoRedoInstance, unityContext }) {
    this.undoRedo = undoRedoInstance;
    this.unityContext = unityContext;
    this.init();
  }

  init = () => {
    this.changeConfiguratorTransformationPanel = this.undoRedo.createAction(
      ({ currentValue, prevValue, isGroup }) => {
        // A prop group is transformed as a whole via its parent object, so unityData.objectId is the
        // group's groupObjectName rather than a selectedObjects[].id - updateObjectTransform matches on
        // id and would silently find nothing, leaving the panel's redux state stale after undo/redo.
        const applyReduxUpdate = (value) => {
          dispatcher(
            isGroup
              ? configuratorUnityObjectActions.updateGroupTransform({
                  groupObjectName: value.unityData.objectId,
                  transformData: value.reduxData,
                })
              : configuratorUnityObjectActions.updateObjectTransform({
                  id: value.unityData.objectId,
                  transformData: value.reduxData,
                })
          );
        };
        const historyValue = {
          data: {
            currentValue,
            prevValue,
            isGroup,
          },
          undo: () => {
            configuratorBridge.UpdateSelectedTransform(prevValue.unityData);
            applyReduxUpdate(prevValue);
          },
          redo: () => {
            configuratorBridge.UpdateSelectedTransform(currentValue.unityData);
            applyReduxUpdate(currentValue);
          },
        };
        return historyValue;
      }
    );
  };
}
